import Cookies from "universal-cookie";

const cookies = new Cookies();

const devuelveDependenciaConstultada = () => {
  try {
    // ========================================================
    // NUEVO SISTEMA: RECUPERAR OBJETOS COMPLETOS
    // ========================================================

    const dependenciasGuardadas =
      localStorage.getItem("dependencias");

    if (dependenciasGuardadas) {
      const dependencias =
        JSON.parse(dependenciasGuardadas);

      if (Array.isArray(dependencias)) {
        dependencias.sort((a, b) =>
          String(a.descripcion || "").localeCompare(
            String(b.descripcion || ""),
            "es",
            {
              sensitivity: "base",
            }
          )
        );

        //console.log( "Dependencias recuperadas completas:", dependencias);

        return dependencias;
      }
    }

    // ========================================================
    // SISTEMA VIEJO: FALLBACK CON COOKIES
    // ========================================================

    const depe = [];

    const cantidad =
      Number(
        cookies.get(
          "cantidadDependencias",
          {
            path: "/",
          }
        )
      ) || 0;

    for (let i = 0; i < cantidad; i++) {
      const padre = cookies.get(
        "DP" + i,
        {
          path: "/",
        }
      );

      depe.push({
        id:
          cookies.get(
            "ID" + i,
            {
              path: "/",
            }
          ) || i + 1,

        descripcion:
          cookies.get(
            "D" + i,
            {
              path: "/",
            }
          ) || "",

        dependenciaPadreId:
          padre === "" ||
          padre === undefined ||
          padre === null
            ? null
            : Number(padre),
      });
    }

    depe.sort((a, b) =>
      String(
        a.descripcion || ""
      ).localeCompare(
        String(
          b.descripcion || ""
        ),
        "es",
        {
          sensitivity: "base",
        }
      )
    );

    console.log(
      "Dependencias recuperadas desde cookies viejas:",
      depe
    );

    return depe;
  } catch (error) {
    console.error(
      "Error recuperando dependencias:",
      error
    );

    return [];
  }
};

export default devuelveDependenciaConstultada;